import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Alert,
} from '@mui/material';
import { requestDocument } from '../../services/documentService';
import { DOCUMENT_CATEGORIES, DOCUMENT_CATEGORY_LABELS } from '../../config/constants';

const categories = Object.entries(DOCUMENT_CATEGORIES).map(([, value]) => ({
  value,
  label: DOCUMENT_CATEGORY_LABELS[value] || value,
}));

const RequestDocumentDialog = ({ open, onClose, studentId, onSuccess }) => {
  const [documentName, setDocumentName] = useState('');
  const [message, setMessage] = useState('');
  const [category, setCategory] = useState('extra_documents');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!documentName.trim()) {
      setError('Document name is required');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await requestDocument(studentId, documentName.trim(), message.trim(), category);
      setDocumentName('');
      setMessage('');
      setCategory('extra_documents');
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Request Document from Student</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}>
        {error && <Alert severity="error" onClose={() => setError(null)}>{error}</Alert>}
        <TextField
          label="Document Name"
          placeholder="e.g. Updated Bank Statement"
          value={documentName}
          onChange={(e) => setDocumentName(e.target.value)}
          fullWidth
          required
          inputProps={{ maxLength: 100 }}
        />
        <TextField
          select
          label="Category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          fullWidth
        >
          {categories.map((c) => (
            <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>
          ))}
        </TextField>
        <TextField
          label="Message (optional)"
          placeholder="Add a note for the student..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          multiline
          rows={2}
          inputProps={{ maxLength: 500 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? 'Sending...' : 'Send Request'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestDocumentDialog;
